import type { RouteObject } from 'react-router-dom'
import { AppShell } from './shell/AppShell'
import { RouteError } from './shell/RouteError'
import { DownloadRoute } from './routes/DownloadRoute'

/**
 * Routes that render inside the tab shell are children of `AppShell`. Surfaces that must render
 * without a tab bar — the login route SHUT-37 adds, mirroring `AuthView` sitting outside the app's
 * `TabView` — belong as siblings of this entry, not children of it.
 *
 * Exported rather than built inline in `main.tsx` so `routes.test.tsx` exercises the configuration
 * the app actually ships. A spec that rebuilds an equivalent tree proves only that the spec's copy
 * is wired correctly, which is the failure mode SHUT-39 exists to close.
 */
export const routes: RouteObject[] = [
  {
    path: '/',
    element: <AppShell />,
    // Reached only when the shell itself fails, or when no child route matches the URL. Both
    // replace the whole frame, tab bar included, because there is no working frame left to render
    // inside.
    errorElement: <RouteError />,
    children: [
      // Per-route error boundaries so a screen that throws is contained by the shell: the error
      // renders in the outlet and the tab bar stays on screen, leaving the user a way out.
      { index: true, element: <DownloadRoute />, errorElement: <RouteError /> },
    ],
  },
]
